import React, { Component } from 'react';
import { omit } from 'lodash';

import ProductOptions from '../views/ProductOptions';
import ClientDetails from '../views/ClientDetails';
import jsonWithStatus from '../utils/jsonWithStatus';

const STEPS = {
  OPTIONS: 'OPTIONS',
  DETAILS: 'DETAILS',
  PAYMENT: 'PAYMENT',
};

class Tunnel extends React.Component {
  constructor(props) {
    super(props);

    const { product, options } = window.options;

    this.state = {
      step: product.has_options ? STEPS.OPTIONS : STEPS.DETAILS,
      option: null,
      details: {},
      detailsErrors: {},
      coupon_code: '',
      product,
      options,
    };
  }

  componentDidMount() {
    document.getElementById('tunnel-loader').remove();
  }

  handleContinue = (option) => {
    this.setState({
      step: STEPS.DETAILS,
      option,
    });
  }

  handleSubmit = ({ details, coupon_code }) => {
    const { product, option } = this.state;

    fetch('/api/boutique/finaliser', {
      method: 'POST',
      body: JSON.stringify({
        product_id: product.id,
        option_id: option ? option.id : '',
        coupon_code,
        ...details,
    	}),
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    })
    .then(jsonWithStatus)
    .then(({ status, data }) => {
      if (data.url) {
        window.location = data.url;
      } else if (status === 422) {
        // If it is a validation error from the API
        this.setState({
          detailsErrors: data.errors,
        });
        console.error('Les données transmises à l\'API ne sont pas valides', data.errors);
      } else {
        throw data.errors || { error: 'Unknown error', data };
      }
    })
    .catch(err => {
      Raven.captureException("Impossible de soumettre la commande", {
        extra: {
          details,
          coupon_code,
          err,
        },
      })
    });
  }

  renderOptions() {
    const { options, product } = this.state;

    return (
      <ProductOptions
        options={options}
        product={product}
        onContinue={this.handleContinue}
      />
    );
  }

  renderDetails() {
    const { product, option, detailsErrors } = this.state;

    return (
      <ClientDetails
        product={product}
        option={option}
        errors={detailsErrors}
        onSubmit={this.handleSubmit}
      />
    );
  }

  render() {
    const { step } = this.state;

    return (
      <div className="bg-light">
        <div className="container-fluid">
          { step === STEPS.OPTIONS && this.renderOptions() }
          { step === STEPS.DETAILS && this.renderDetails() }
        </div>
      </div>
    );
  }
}

export default Tunnel;
